export default __webpack_public_path__ + "static/media/AboutUs.5d346d42.png";